export const REGISTRATION_IPHONE_MAX_WIDTH_PX = 767;
export const REGISTRATION_IPAD_MINI_MIN_WIDTH_PX = 768;
export const REGISTRATION_IPAD_MINI_MAX_WIDTH_PX = 1099;
export const REGISTRATION_M_MIN_WIDTH_PX = 1100;
export const REGISTRATION_M_MAX_WIDTH_PX = 1399;
export const REGISTRATION_M_MAX_HEIGHT_PX = 900;
export const REGISTRATION_L_MIN_WIDTH_PX = 1400;
export const REGISTRATION_L_MAX_WIDTH_PX = 1679;
export const REGISTRATION_XL_MIN_WIDTH_PX = 1680;

export const REGISTRATION_TWO_COLUMN_LAYOUT_MAX_WIDTH_XL_PX = 1728;
export const REGISTRATION_TWO_COLUMN_LAYOUT_MAX_WIDTH_L_PX = 1440;
export const REGISTRATION_TWO_COLUMN_LAYOUT_MAX_WIDTH_M_PX = 1192;
export const REGISTRATION_SINGLE_COLUMN_LAYOUT_MAX_WIDTH_IPAD_PX = 744;
export const REGISTRATION_SINGLE_COLUMN_LAYOUT_MAX_WIDTH_IPHONE_PX = 393;

export const REGISTRATION_FORM_BOX_WIDTH_TWO_COLUMN_XL_PX = 680;
export const REGISTRATION_FORM_BOX_WIDTH_TWO_COLUMN_L_PX = 660;
export const REGISTRATION_FORM_BOX_WIDTH_TWO_COLUMN_M_PX = 536;
export const REGISTRATION_FORM_BOX_WIDTH_IPAD_PX = 536;
export const REGISTRATION_FORM_BOX_WIDTH_IPHONE_PX = 357;
export const REGISTRATION_TWO_COLUMN_GAP_XL_L_PX = 27;
export const REGISTRATION_TWO_COLUMN_GAP_M_PX = 21;

export const REGISTRATION_SINGLE_COLUMN_MAX_WIDTH_PX = 1166;
export const REGISTRATION_TWO_COLUMN_WIDTH_PX =
  REGISTRATION_FORM_BOX_WIDTH_TWO_COLUMN_XL_PX;
export const REGISTRATION_FORM_CONTENT_MAX_WIDTH_PX = 393;
export const REGISTRATION_FORM_CONTENT_MOBILE_MAX_WIDTH_PX = 305;
export const REGISTRATION_COMPACT_BREAKPOINT_MIN_PX =
  REGISTRATION_IPAD_MINI_MIN_WIDTH_PX;
export const REGISTRATION_COMPACT_BREAKPOINT_MAX_PX =
  REGISTRATION_IPAD_MINI_MAX_WIDTH_PX;
export const REGISTRATION_COMPACT_BOX_WIDTH_MIN_PX =
  REGISTRATION_FORM_BOX_WIDTH_IPHONE_PX;
export const REGISTRATION_COMPACT_BOX_WIDTH_MAX_PX =
  REGISTRATION_FORM_BOX_WIDTH_IPAD_PX;
export const REGISTRATION_TESTIMONIAL_CARD_WIDTH_PX = 470;
export const REGISTRATION_TESTIMONIAL_CARD_GAP_PX = 24;
export const REGISTRATION_TESTIMONIAL_VIEWPORT_MAX_WIDTH_PX = 653;
export const REGISTRATION_DESKTOP_MIN_WIDTH_PX = REGISTRATION_M_MIN_WIDTH_PX;

export const REGISTRATION_SINGLE_COLUMN_MAX_WIDTH = `${REGISTRATION_SINGLE_COLUMN_MAX_WIDTH_PX}px`;
export const REGISTRATION_TWO_COLUMN_WIDTH = `${REGISTRATION_TWO_COLUMN_WIDTH_PX}px`;
export const REGISTRATION_FORM_CONTENT_MAX_WIDTH = `${REGISTRATION_FORM_CONTENT_MAX_WIDTH_PX}px`;
export const REGISTRATION_FORM_CONTENT_MOBILE_MAX_WIDTH = `${REGISTRATION_FORM_CONTENT_MOBILE_MAX_WIDTH_PX}px`;
export const REGISTRATION_TWO_COLUMN_GAP_XL_L = `${REGISTRATION_TWO_COLUMN_GAP_XL_L_PX}px`;
export const REGISTRATION_TWO_COLUMN_GAP_M = `${REGISTRATION_TWO_COLUMN_GAP_M_PX}px`;
const REGISTRATION_COMPACT_BOX_WIDTH_SLOPE =
  (REGISTRATION_COMPACT_BOX_WIDTH_MAX_PX -
    REGISTRATION_COMPACT_BOX_WIDTH_MIN_PX) /
  (REGISTRATION_COMPACT_BREAKPOINT_MAX_PX +
    1 -
    REGISTRATION_COMPACT_BREAKPOINT_MIN_PX);
const REGISTRATION_COMPACT_BOX_WIDTH_INTERCEPT =
  REGISTRATION_COMPACT_BOX_WIDTH_MIN_PX -
  REGISTRATION_COMPACT_BOX_WIDTH_SLOPE * REGISTRATION_COMPACT_BREAKPOINT_MIN_PX;

export const REGISTRATION_COMPACT_BOX_WIDTH = `clamp(${REGISTRATION_COMPACT_BOX_WIDTH_MIN_PX}px, calc(${REGISTRATION_COMPACT_BOX_WIDTH_INTERCEPT.toFixed(
  4,
)}px + ${(REGISTRATION_COMPACT_BOX_WIDTH_SLOPE * 100).toFixed(
  4,
)}vw), ${REGISTRATION_COMPACT_BOX_WIDTH_MAX_PX}px)`;
export const REGISTRATION_IPHONE_MEDIA_QUERY = `screen and (max-width: ${REGISTRATION_IPHONE_MAX_WIDTH_PX}px)`;
export const REGISTRATION_IPAD_MINI_MEDIA_QUERY = `screen and (min-width: ${REGISTRATION_IPAD_MINI_MIN_WIDTH_PX}px) and (max-width: ${REGISTRATION_IPAD_MINI_MAX_WIDTH_PX}px)`;
export const REGISTRATION_M_MEDIA_QUERY = `screen and (min-width: ${REGISTRATION_M_MIN_WIDTH_PX}px) and (max-width: ${REGISTRATION_M_MAX_WIDTH_PX}px), screen and (min-width: ${REGISTRATION_M_MIN_WIDTH_PX}px) and (max-height: ${REGISTRATION_M_MAX_HEIGHT_PX}px)`;
export const REGISTRATION_L_MEDIA_QUERY = `screen and (min-width: ${REGISTRATION_L_MIN_WIDTH_PX}px) and (max-width: ${REGISTRATION_L_MAX_WIDTH_PX}px)`;
export const REGISTRATION_XL_MEDIA_QUERY = `screen and (min-width: ${REGISTRATION_XL_MIN_WIDTH_PX}px)`;
export const REGISTRATION_COMPACT_MEDIA_QUERY = `screen and (max-width: ${REGISTRATION_COMPACT_BREAKPOINT_MAX_PX}px)`;
export const REGISTRATION_DESKTOP_MEDIA_QUERY = `(min-width: ${REGISTRATION_DESKTOP_MIN_WIDTH_PX}px)`;
export const REGISTRATION_TWO_COLUMN_LAYOUT_MAX_WIDTH_XL = `${REGISTRATION_TWO_COLUMN_LAYOUT_MAX_WIDTH_XL_PX}px`;
export const REGISTRATION_TWO_COLUMN_LAYOUT_MAX_WIDTH_L = `${REGISTRATION_TWO_COLUMN_LAYOUT_MAX_WIDTH_L_PX}px`;
export const REGISTRATION_TWO_COLUMN_LAYOUT_MAX_WIDTH_M = `${REGISTRATION_TWO_COLUMN_LAYOUT_MAX_WIDTH_M_PX}px`;
export const REGISTRATION_SINGLE_COLUMN_LAYOUT_MAX_WIDTH_IPAD = `${REGISTRATION_SINGLE_COLUMN_LAYOUT_MAX_WIDTH_IPAD_PX}px`;
export const REGISTRATION_SINGLE_COLUMN_LAYOUT_MAX_WIDTH_IPHONE = `${REGISTRATION_SINGLE_COLUMN_LAYOUT_MAX_WIDTH_IPHONE_PX}px`;
export const REGISTRATION_FORM_BOX_WIDTH_TWO_COLUMN_XL = `${REGISTRATION_FORM_BOX_WIDTH_TWO_COLUMN_XL_PX}px`;
export const REGISTRATION_FORM_BOX_WIDTH_TWO_COLUMN_L = `${REGISTRATION_FORM_BOX_WIDTH_TWO_COLUMN_L_PX}px`;
export const REGISTRATION_FORM_BOX_WIDTH_TWO_COLUMN_M = `${REGISTRATION_FORM_BOX_WIDTH_TWO_COLUMN_M_PX}px`;
export const REGISTRATION_FORM_BOX_WIDTH_IPAD = `${REGISTRATION_FORM_BOX_WIDTH_IPAD_PX}px`;
export const REGISTRATION_FORM_BOX_WIDTH_IPHONE = `${REGISTRATION_FORM_BOX_WIDTH_IPHONE_PX}px`;
export const REGISTRATION_TESTIMONIAL_CARD_WIDTH = `${REGISTRATION_TESTIMONIAL_CARD_WIDTH_PX}px`;
export const REGISTRATION_TESTIMONIAL_VIEWPORT_MAX_WIDTH = `${REGISTRATION_TESTIMONIAL_VIEWPORT_MAX_WIDTH_PX}px`;
